$(function() {
	if (!$body.hasClass('page-sitemap'))
		return;

	var links = $('section.sitemap li a');

	links.click(function() {
		var a = $(this);
		var li = a.parent();
		if (a.attr('href') == '#') {
			var child = li.find('> ul > li:first-child > a');
			if (child && child.attr('href'))
				window.location = child.attr('href');
			return false;
		}
	});

});